import React, {PureComponent} from 'react';
import PropTypes from 'prop-types';
import {withStyles} from "@material-ui/core";
import ErrorMessage from '../ErrorMessage';

class ErrorBoundary extends PureComponent {
    static propTypes = {
        classes: PropTypes.object,
        children: PropTypes.oneOfType([PropTypes.node, PropTypes.array]),
    };

    state = {error: undefined, errorInfo: undefined};

    componentDidCatch(error, errorInfo) {
        this.setState({
            error,
            errorInfo,
        });
    }

    render() {
        const {error, errorInfo} = this.state;
        const {children, classes} = this.props;
        if (errorInfo) {
            const errorDetails = process.env.NODE_ENV === 'development' ? (
                <details className="errorDetails">
                    {error && error.toString()}
                    <br/>
                    {errorInfo.componentStack}
                </details>
            ) : undefined;
            return (
                <div className={classes.errorBoundary}>
                    <ErrorMessage>
                        :( We detected an unexpected error, don't worry, we are working on it.
                    </ErrorMessage>
                    {errorDetails}
                </div>
            );
        }
        return children;
    }
}

const ErrorBoundaryStyled = withStyles(() => ({
    errorBoundary: {
        '& .errorDetails': {
            marginTop: 30,
            whiteSpace: 'pre-wrap',
        },
        '& .errorMessage': {
            textAlign: 'center'
        }
    },
}))(ErrorBoundary);

export default ErrorBoundaryStyled;

export const errorBundaryHOC = Component => props => (
    <ErrorBoundaryStyled>
        <Component {...props} />
    </ErrorBoundaryStyled>
);
